export const paginationDefault = {
  limit: 10,
  page: 1,
}
